<template>
  <div>
    <a v-on:click="clickEvent()" style="cursor:pointer;" :id="id">
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="40" height="40" viewBox="0 0 49 49">
        <defs>
          <filter id="Ellipse_70" x="0" y="0" width="56" height="56" filterUnits="userSpaceOnUse">
            <feOffset dy="3" input="SourceAlpha"/>
            <feGaussianBlur stdDeviation="1.5" result="blur"/>
            <feFlood flood-opacity="0.161"/>
            <feComposite operator="in" in2="blur"/>
            <feComposite in="SourceGraphic"/>
          </filter>
        </defs>
        <g id="Group_2930" data-name="Group 2930" transform="translate(-1275.5 7957.896)">
          <g transform="matrix(1, 0, 0, 1, 1275.5, -7957.9)" filter="url(#Ellipse_70)">
            <circle id="Ellipse_70-2" data-name="Ellipse 70" cx="20" cy="20" r="20" transform="translate(4.5 1.5)" fill="#dce1e2"/>
          </g>
          <g id="Group_2931" data-name="Group 2931" transform="translate(-1522.385 -8907.99) rotate(-45)">
            <line id="Line_13" data-name="Line 13" y2="25" transform="translate(1308.5 2670.5)" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="4"/>
            <line id="Line_14" data-name="Line 14" x2="25" transform="translate(1295.5 2683.5)" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="4"/>
          </g>
        </g>
      </svg>
    </a>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  props: ['argument', 'id'],
  name: 'DeleteButtonComponent',
  methods: {
    clickEvent() {
      this.$emit('click-event-delete-button', this.argument)
    }
  }
}
</script>
